<div
  class="cookie-consent-backdrop"
  *ngIf="isOpen() && isEnabled()"
  aria-hidden="true"
></div>

<div
  class="modal fade show cookie-consent-modal"
  *ngIf="isOpen() && isEnabled()"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  aria-labelledby="cookieConsentTitle"
>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content shadow">
      <div class="modal-header border-0 pb-0">
        <div>
          <p class="text-uppercase text-primary fw-semibold small mb-1">Privacy &amp; Cookies</p>
          <h5 class="modal-title" id="cookieConsentTitle">Your privacy choices on YachtApp</h5>
        </div>
        <button type="button" class="btn-close" aria-label="Close" (click)="cookieConsentService.closeModal()"></button>
      </div>
      <div class="modal-body pt-3">
        <p class="text-muted">
          We use essential cookies to keep YachtApp secure and working. With your permission, we also use
          analytics and marketing cookies to understand usage, improve performance, and personalize content.
          You can change these settings at any time in the footer or by clearing your browser storage.
        </p>

        <div class="alert alert-light border mt-3">
          <div class="d-flex flex-column flex-lg-row gap-3">
            <div class="flex-grow-1">
              <h6 class="mb-1">Essential cookies &amp; sessions</h6>
              <p class="small text-muted mb-0">
                Required for login sessions, security, and preferences. These are always on and cannot be disabled.
              </p>
            </div>
            <div class="text-nowrap align-self-lg-center">
              <span class="badge bg-success-subtle text-success border border-success-subtle">Always active</span>
            </div>
          </div>
        </div>

        <button
          class="btn btn-link px-0 mt-2"
          type="button"
          (click)="togglePreferences()"
        >
          {{ showPreferences() ? 'Hide cookie details' : 'Manage cookie preferences' }}
        </button>

        <div class="border rounded-3 p-3" *ngIf="showPreferences()">
          <div class="d-flex flex-column gap-3">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <h6 class="mb-1">Analytics cookies</h6>
                <p class="small text-muted mb-0">
                  Helps us understand which features are most useful and keeps our navigation improvements on course.
                </p>
              </div>
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="analyticsCookies"
                  [checked]="analyticsAllowed()"
                  (change)="analyticsAllowed.set(!analyticsAllowed())"
                >
                <label class="form-check-label" for="analyticsCookies">
                  {{ analyticsAllowed() ? 'On' : 'Off' }}
                </label>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-start">
              <div>
                <h6 class="mb-1">Marketing cookies</h6>
                <p class="small text-muted mb-0">
                  Used to show relevant offers and track campaign performance. We only enable these when you opt in.
                </p>
              </div>
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="marketingCookies"
                  [checked]="marketingAllowed()"
                  (change)="marketingAllowed.set(!marketingAllowed())"
                >
                <label class="form-check-label" for="marketingCookies">
                  {{ marketingAllowed() ? 'On' : 'Off' }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <h6 class="mb-1">How we honor your choice</h6>
          <ul class="small text-muted ps-3 mb-0">
            <li>We store your preference locally in your browser (first-party localStorage).</li>
            <li>Non-essential cookies and sessions are blocked until you opt in.</li>
            <li>If you opt out, we remove any non-essential cookies and storage keys we have set.</li>
          </ul>
        </div>
      </div>
      <div class="modal-footer border-0 pt-0">
        <button class="btn btn-outline-secondary" type="button" (click)="rejectAll()">Reject non-essential</button>
        <button class="btn btn-outline-primary" type="button" (click)="savePreferences()">Save preferences</button>
        <button class="btn btn-primary" type="button" (click)="acceptAll()">Accept all</button>
      </div>
    </div>
  </div>
</div>
